module.exports = __webpack_public_path__ + "media/images/common/shop/icon-station-740e49421cc84b9d964b5d930161ac13.png";